import { Heading, Text, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { HeaderCards } from '../HeaderCards';
import { PillButton } from '../PillButton';

export namespace RateManagementHeaderSectionTypes {
  export interface Props {
    isMobile?: boolean;
  }
}

export const HeaderSection: React.FC<RateManagementHeaderSectionTypes.Props> = ({ isMobile }) => {
  return (
    <>
      <HStack justifyContent={'space-between'} alignItems={'center'} space={Spacing['inline.xxxs']}>
        <HStack alignItems={'center'} space={Spacing['inset.nano']}>
          {isMobile ? (
            <Text
              color="brand.primary.principal"
              fontWeight={Typography['fontweight.semibold']}
              fontSize={Typography['fontsize.lg']}
              variant="semibold">
              Gerenciamento de taxas
            </Text>
          ) : (
            <Heading testId="qa" size="h2">
              Gerenciamento de taxas
            </Heading>
          )}
        </HStack>
        {!isMobile && <PillButton />}
      </HStack>
      {!isMobile && <HeaderCards />}
    </>
  );
};
